import { INSTANT_GAME_TYPE, updateGameImage } from 'app/actions/game-images.actions';
import { validateDimensions, validateFileFormat } from 'utils/file-upload/file-helpers';
import template from './game-card.html';

const mapStateToThis = ({ gameImages }) => {
  const { newImages } = gameImages;

  return {
    newImages,
  };
};

const mapDispatchToThis = {
  updateGameImage,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$document', 'Notifications', 'gettextCatalog')
class GameCardController {
  constructor() {
    this.INSTANT_GAME_TYPE = INSTANT_GAME_TYPE;
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  getImage() {
    const newImage = this.newImages.find((image) => this.game.id === image.gameId);
    return newImage ? newImage.image : this.game.imageURL;
  }

  addImage() {
    this.$document[0].getElementById(`game-image-${this.game.id}`).click();
  }

  async fileUploadChange($event) {
    const file = $event.target.files[0];
    const fileReader = new FileReader();
    fileReader.onerror = () => {
      fileReader.abort();
      this.showFileReadError();
    };
    fileReader.readAsDataURL(file);
    fileReader.onloadend = this.fileReaderOnLoadEnd.bind(this, file, fileReader);
  }

  async fileReaderOnLoadEnd(file, fileReader) {
    const fileResult = fileReader.result;
    const isValidFile = await this.validateFile(file, fileResult);
    if (isValidFile) {
      const gameImage = {
        gameId: this.game.id,
        image: fileResult,
      };
      this.updateGameImage(gameImage);
      this.onFileChanged();
    }
  }

  async validateFile(file, fileResult) {
    const isValidFileFormat = validateFileFormat(file.type, this.acceptFileFormat);
    if (!isValidFileFormat) {
      if (this.acceptFileFormat.length > 1) {
        this.Notifications.alertWarning(this.gettextCatalog.getString('Only {{ acceptFileFormat }} formats are acceptable!', { acceptFileFormat: this.acceptFileFormat.join(', ') }));
      } else {
        this.Notifications.alertWarning(this.gettextCatalog.getString('Only {{ acceptFileFormat }} format is acceptable!', { acceptFileFormat: this.acceptFileFormat.join(', ') }));
      }
      return false;
    }
    const isValidFileDimensions = await validateDimensions(fileResult, this.acceptFileDimensions);
    if (isValidFileDimensions === 'error') {
      this.showFileReadError();
    } else if (isValidFileDimensions === false) {
      if (this.acceptFileDimensions.length === 1) {
        this.Notifications.alertWarning(this.gettextCatalog.getString('Images should be {{ widthFirst }}px width and {{ heightFirst }}px height!',
          {
            widthFirst: this.acceptFileDimensions[0].width,
            heightFirst: this.acceptFileDimensions[0].height,
          }));
      } else if (this.acceptFileDimensions.length === 2) {
        this.Notifications.alertWarning(this.gettextCatalog.getString('Images should be {{ widthFirst }}px width and {{ heightFirst }}px height or {{ widthSecond }}px width and {{ heightSecond }}px height!',
          {
            widthFirst: this.acceptFileDimensions[0].width,
            heightFirst: this.acceptFileDimensions[0].height,
            widthSecond: this.acceptFileDimensions[1].width,
            heightSecond: this.acceptFileDimensions[1].height,
          }));
      }
      return false;
    }
    return true;
  }

  showFileReadError() {
    this.Notifications.alertWarning(this.gettextCatalog.getString('Something went wrong during file processing. Please try again or change the file.'));
  }
}

export default class GameCardComponent {
  constructor() {
    this.controller = GameCardController;
    this.template = template;
    this.transclude = true;
    this.bindings = {
      type: '<',
      game: '<',
      acceptFileFormat: '<',
      acceptFileDimensions: '<',
      onFileChanged: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/game-images/components/game-card/game-card-component.js